import { render, staticRenderFns } from "./Rekening.vue?vue&type=template&id=7b4e16f2"
import script from "./Rekening.vue?vue&type=script&lang=js"
export * from "./Rekening.vue?vue&type=script&lang=js"
import style0 from "./Rekening.vue?vue&type=style&index=0&id=7b4e16f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports